<template>
  <div class="fb fb-col height-full relative w-full x-hidden">
    <div>
      <md-searchbar v-model="keyword"></md-searchbar>
      <div class="h-44 p-0-16 font-32 fb fb-cross-center address-nav">
        <div
          v-for="(item, index) in history"
          :key="index"
          @click="back(item, index)"
          class="inline-block"
          :class="index === 0 ? '' : 'ml-8'"
        >
          <span
            :class="{
              'c-006AFE': index < history.length - 1,
              'c-171A1D-60': index === history.length - 1
            }"
            >{{ item.deptName }}</span
          >
          <i
            class="iconfont font-28 c-171A1D-40"
            v-if="index < history.length - 1"
            >&#xe68d;</i
          >
        </div>
      </div>
    </div>
    <div v-if="list.length" class="item-flex-1 scroll-y pb-80">
      <div
        class="font-34 ff-regular bg-FFFFFF pl-16"
        v-for="(item, index) in list"
        :key="index"
      >
        <template v-if="item.memberId">
          <div class="fb fb-main-between fb-cross-center h-64">
            <div class="pr-12 fb fb-main-between fb-cross-center">
              <div
                class="tree-name font-28 fb fb-main-center fb-cross-center c-FFFFFF"
              >
                <span>{{ item.memberName.slice(0, 2) }}</span>
              </div>
            </div>
            <div
              class="item-flex-1 fb fb-main-start fb-cross-center pr-16 height-full"
              :class="{
                'bb-111F2C-12': index < list.length - 1
              }"
              @click="form(item)"
            >
              <div class="item-flex-1">
                <div class="c-171A1D lh-24">{{
                  filterName(item.memberName, 10)
                }}</div>
                <div class="font-28 c-171A1D-40 lh-20">{{
                  filterName(item.deptName, 10)
                }}</div>
              </div>
              <div class="w-84 c-171A1D-40 fb fb-main-start fb-cross-center">
                <div v-if="!item.identityStatus && !keyword">待完善</div>
                <i class="iconfont">&#xe68d;</i>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="pr-8 h-56 fb fb-main-between fb-cross-center"
            :class="{
              'bb-111F2C-12': index < list.length - 1
            }"
          >
            <div class="item-flex-1 text-ellipsis">
              <span class="mr-8">{{
                filterName(item.deptName || item.memberName, 10)
              }}</span>
              <span :class="item.selStudentCnt ? 'c-006AFE' : 'c-171A1D-40'"
                >({{ item.selStudentCnt }}/{{ item.studentCnt }})</span
              >
            </div>
            <div
              class="w-72 pl-10 c-006AFE bl-111F2C-24"
              @click="nextSeason(item)"
            >
              <i class="iconfont">&#xe714;</i>
              下级</div
            >
          </div>
        </template>
      </div>
    </div>
    <div v-else class="relative item-flex-1">
      <common-no-data class="no-record w-fullVw h-258">
        <div class="no-course no-item"></div>
        <p class="font-28 c-171A1D-40">暂无记录</p>
      </common-no-data>
    </div>
    <div
      class="footer fb fb-main-between fb-cross-center"
      @click="dingNotice"
      v-if="!keyword"
    >
      <md-button>{{ noticeMsg }}</md-button>
    </div>
  </div>
</template>

<script>
import { deepCopy, filterName } from '@/utils/comUtils'
import API from '@/api'
import { SANDBOX_TYPE } from '@/utils/constUtils'
import { mapGetters } from 'vuex'
import mixin from '@/mixin'
import {
  mcHidePreloader,
  mcShowPreloader,
  mcToast,
  mcCreateMessage
} from '@/utils/mcSdkUtils'
import { commonNoData } from '@/components'

export default {
  name: 'PageParentChild',
  mixins: [mixin],
  components: {
    commonNoData
  },
  data() {
    return {
      filterName,
      list: [],
      keyword: '',
      isDestroyed: false
    }
  },
  watch: {
    async keyword(newValue, oldValue) {
      if (newValue) {
        const res = await API.searchOrgMember({
          memberName: newValue,
          operUserRoleTypes: this.currentRole
        })
        if (res && res.result && res.result !== '0') {
          return false
        }
        this.list = res
      } else {
        this.ajaxPolling(this.faceSandBoxId, +this.$route.params.id)
      }
    }
  },
  computed: {
    ...mapGetters(['faceSandBoxId']),
    currentIndex() {
      let data = this.$store.getters.history || []
      let index = data.findIndex(item => item.deptId === this.$route.params.id)
      return index === -1 ? 0 : index
    },
    history() {
      return this.$store.getters.history || []
    },
    noticeMsg() {
      return '通知教职工完善身份信息'
    }
  },
  created() {
    mcShowPreloader({ text: '初始化···' })
    if (this.faceSandBoxId) {
      this.ajaxPolling(this.faceSandBoxId, +this.$route.params.id)
    } else {
      this.createSandBox()
    }
    this.$nextTick(() => {
      let history = this.$store.getters.history || []
      let data = []
      for (let index = 0; index < history.length; index++) {
        const element = history[index]
        data.push(element)
        if (element.deptId === this.$route.params.id) {
          break
        }
      }
      this.$store.commit('setHistory', data)
    })
  },
  destroyed() {
    this.isDestroyed = true
  },
  methods: {
    // 发送ding通知
    dingNotice() {
      let deptIds = []
      if (this.keyword) {
        deptIds = this.list.map(item => item.tpId)
        mcCreateMessage({
          users: deptIds,
          corpId: this.corpId,
          text: `请${this.corpName}的教职工完善个人及学生身份信息。`,
          attachment: {
            title: '录入个人身份信息',
            text: '一键录入，简单高效',
            url: `${this.h5Host}/?corpId=${this.corpId}#/?redircetHash=%2FentryInformation%2Findex&currentRole=100&role=-1&campusId=${this.campusId}&myRole=1`,
            image: `${this.h5Host}/static/img/ding-notice.png`
          }
        })
      } else {
        let id =
          +this.$route.params.id === 0
            ? this.list[0].deptTpId
            : this.$route.query.deptTpId
        deptIds = id ? [id] : []
        mcShowPreloader({ text: '加载中' })
        API.getUserNoticeList({
          sandboxId: this.faceSandBoxId,
          operUserRoleTypes: this.$store.getters.currentRole, // 当前角色
          deptIds,
          userType: 1
        })
          .then(res => {
            mcHidePreloader()
            if (res && res.result && res.result !== '0') {
              mcToast({ msg: res.message })
              return false
            }
            mcCreateMessage({
              users: res,
              corpId: this.corpId,
              text: `请${this.corpName}的教职工完善个人及学生身份信息。`,
              attachment: {
                title: '录入个人身份信息',
                text: '一键录入，简单高效',
                url: `${this.h5Host}/?corpId=${this.corpId}#/?redircetHash=%2FentryInformation%2Findex&currentRole=100&role=-1&campusId=${this.campusId}&myRole=1`,
                image: `${this.h5Host}/static/img/ding-notice.png`
              }
            })
          })
          .catch(() => {
            mcHidePreloader()
          })
      }
    },
    createSandBox() {
      API.createUserSandBox({
        campusId: (this.$store.getters.currentCapmus || {}).tpId || '', // 校区ID
        operUserRoleType: this.$store.getters.currentRole, // 当前角色
        sandboxType: SANDBOX_TYPE.staff
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcHidePreloader()
            mcToast({ msg: res.message })
            this.$store.commit('setFaceSandBoxId', '')
            return false
          }
          this.ajaxPolling(res)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    ajaxPolling(sandboxId, deptTpId) {
      if (this.isDestroyed) {
        mcHidePreloader()
        return false
      }
      API.sandBoxStatus({
        calcStudentSelCnt: true,
        sandboxId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcHidePreloader()
            mcToast({ msg: res.message })
            this.$store.commit('setFaceSandBoxId', '')
            return false
          }
          if (res.sandboxStatus === 2) {
            // 沙盒已准备好，保存一下沙盒ID
            this.$store.commit('setFaceSandBoxId', sandboxId)
            this.getSubNodes(sandboxId, deptTpId)
          } else if (res.sandboxStatus === 8) {
            this.createSandBox()
          } else {
            setTimeout(() => {
              this.ajaxPolling(sandboxId)
            }, 1500)
          }
        })
        .catch(() => {
          mcHidePreloader()
        })
    },
    getSubNodes(sandboxId, deptTpId) {
      API.sandBoxSubNodes({
        parentDeptId: deptTpId || null,
        sandboxId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcHidePreloader()
            mcToast({ msg: res.message })
            this.$store.commit('setFaceSandBoxId', '')
            return false
          }
          mcHidePreloader()
          if (!deptTpId && (res[0] || {}).deptTpId === '1') {
            this.nextSeason(res[0])
            return
          }
          this.list = res
          if (this.$route.query.deptId) {
            API.getDeptMembers({
              deptId: this.$route.query.deptId,
              campusId: this.campusId
            })
              .then(response => {
                if (response && response.result && response.result !== '0') {
                  return false
                }
                this.list = res.concat(response)
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          }
        })
        .catch(() => {
          mcHidePreloader()
        })
    },

    nextSeason(item, isReplace) {
      let history = deepCopy(this.$store.getters.history || [])
      history.push(item)
      this.$store.commit('setHistory', history)
      this.$router.replace({
        path: `/entryInformation/org/${item.deptTpId || 0}`,
        query: item
      })
    },
    back(item, index) {
      let history = this.$store.getters.history || []
      let data = []
      for (let index = 0; index < history.length; index++) {
        const element = history[index]
        data.push(element)
        if (element.deptId === item.deptId) {
          break
        }
      }
      this.$nextTick(() => {
        this.$store.commit('setHistory', data)
      })
      this.$router.replace({
        path: `/entryInformation/org/${item.deptTpId || 0}`,
        query: item
      })
    },
    form(item) {
      this.$router.push({
        path: '/entryInformation/form',
        query: {
          imgClass: item.imgClass || '',
          memberId: item.memberId,
          userType: 1,
          sandboxId: this.$store.getters.faceSandBoxId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bl-111F2C-24 {
  border-left: 1px solid rgba(17, 31, 44, 0.24);
}
.bb-111F2C-12 {
  border-bottom: 1px solid rgba(17, 31, 44, 0.12);
}
.tree-name {
  background: #006afe;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.no-record {
  .no-course {
    width: 180px;
    height: 180px;
    &.no-item {
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
.address-nav {
  overflow-y: hidden;
  overflow-x: scroll;
  & > div {
    flex-shrink: 0;
  }
}
</style>
